import { React, useEffect, useState } from 'react'
import styles from './PolicyAttestation.module.scss'
import usePolicyAttestation from './usePolicyAttestation'
import { useLocation } from 'react-router-dom'
import { USER_AUTH_KEY } from '../../utils/constants'
//import { useNavigate } from 'react-router-dom'

const PolicyAttestation = () => {

  const [isStorageReady, setStorageReady] = useState(false)

  const excludedPaths = ['/privacy-policy', '/terms-of-use', '/signout']
  const isExcludedPath = excludedPaths.includes(window.location.pathname)

  useEffect(() => {
    const checkStorageReady = () => {
      const requester = window.localStorage.getItem('requester')
      const user = window.localStorage.getItem(USER_AUTH_KEY)
      if (requester && user && !isExcludedPath) {
        setStorageReady(true)
      } else {
        setTimeout(checkStorageReady, 200)
      }
    }

    checkStorageReady()
  }, [])

  const {
    isPolicyAttested,
    isChecked,
    isContinueClicked,
    onCheckChanged,
    onContinueClick,
    onClose,
  } = usePolicyAttestation()

  if (!isStorageReady || !isPolicyAttested) return null

  return (
    <div className={styles.modaloverlay}>
      <div className={styles.modal}>
        <h1>We've updated our terms of service.</h1>
        <p>
          Please review and accept the following terms of service to access the
          application.
        </p>
        {/* <form onSubmit={onAccepted}> */}
          <label className={styles.checkboxcontainer}>
            <input
              type="checkbox"
              checked={isChecked}
              onChange={onCheckChanged}
              required
            />
            <span className={styles.checkmark}></span>
            <span>
            By selecting this checkbox, I have reviewed and agree to the <br /> {' '}
            </span>
            <span className={styles.linkwithicon}>
              <a
                href={`${window.location.origin}/privacy-policy`}
                target="_blank" style={{'margin-left' : '2rem'}}>              
                Privacy Policy
                <i className={styles.icon} />
              </a>
            </span>
            and {'   '}
            <span className={styles.linkwithicon}>
            <a href={`${window.location.origin}/terms-of-use`} target="_blank">
            {' '} Terms of Use
              <i className={styles.icon} />
            </a>
            </span>
          </label>
          <div className={styles.buttongroup}>
            <button type="button" className={styles.acceptbtn} disabled={!isChecked} onClick={onContinueClick}>
              Accept & Continue
            </button>
            <button
              type="button"
              className={styles.declinebtn}
              onClick={onClose}
            >
              Decline
            </button>
          </div>
        {/* </form> */}
      </div>
    </div>
  )
}

export default PolicyAttestation
